module.exports = __webpack_public_path__ + "img/home-about.90cd74e1.jpg";